import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/creators/{creatorId}/organization' as const;

export type OrganizationApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

export const useOrganization = (
  params: OrganizationApi['params'] | null,
  config?: UseNoodleSwrConfig<OrganizationApi['response']>,
): SWRResponse<OrganizationApi['response'], ApiError> => {
  const path = params ? buildPath<OrganizationApi>(PATH_TEMPLATE, params) : null;
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useOrganization` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getOrganization = async ({ creatorId }: OrganizationApi['params']): Promise<OrganizationApi['response']> => {
  const path = buildPath<OrganizationApi>(PATH_TEMPLATE, { creatorId });
  const data = await noodleApiClient.get(path);
  return data.data;
};

export default getOrganization;
